module.exports = __webpack_public_path__ + "img/ondivan_marca_white_slogan.df6e07f1.svg";